import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    wrap: {
        display: 'flex',
        gap: 4,
        padding: 4,
        marginBottom: 8,
        borderRadius: 10,
        backgroundColor: '#f3f5f8',
        width: 'fit-content',
    },
    button: {
        border: 0,
        background: 'transparent',
        color: '#1C375D',
        fontWeight: 700,
        fontSize: 13,
        padding: '8px 16px',
        borderRadius: 8,
        cursor: 'pointer',
    },
    active: {
        backgroundColor: '#1C375D',
        color: '#fff',
    },
}));

export default function LeadChannelSwitch({ value, onChange }) {
    const classes = useStyles();
    if (!onChange) return null;
    return (
        <div className={classes.wrap} role="tablist" aria-label="Lead dashboard">
            <button
                type="button"
                role="tab"
                aria-selected={value === 'both'}
                className={`${classes.button} ${value === 'both' ? classes.active : ''}`}
                onClick={() => onChange('both')}
            >
                Both
            </button>
            <button
                type="button"
                role="tab"
                aria-selected={value === 'meta'}
                className={`${classes.button} ${value === 'meta' ? classes.active : ''}`}
                onClick={() => onChange('meta')}
            >
                Meta Lead
            </button>
            <button
                type="button"
                role="tab"
                aria-selected={value === 'google'}
                className={`${classes.button} ${value === 'google' ? classes.active : ''}`}
                onClick={() => onChange('google')}
            >
                Google Leads
            </button>
        </div>
    );
}
